// CONSTANTS
const ONE_HUNDRED_PERCENT = 100;
const NUM_OF_DECIMALS = 2;

/**
 * Rounds up number to 2 decimal places
 * @param valueToRound Value to be rounded up
 * @returns Rounded up value
 */
export const roundUpNumber = (valueToRound: number): number => Math.ceil(valueToRound * ONE_HUNDRED_PERCENT) / ONE_HUNDRED_PERCENT;

/**
 * Formats dollar amount into a string with $ prefix and fixed to 2 decimal places
 * @param valueToFormat Dollar amount to be formatted
 * @param formatCurrency Format currency method from context.cultureFormatter that uses the current channels financial unit
 * @returns Formatted dollar amount as a string
 */
export const formatAmountToString = (valueToFormat: number, formatCurrency: (price: string) => string): string =>
    `${formatCurrency(valueToFormat.toFixed(NUM_OF_DECIMALS))}`;
